import * as R from 'ramda'

export const whenIsObject = R.when(R.is(Object))
